// src/index.ts
import PermissionService from './PermissionService';
import usePermissions from './hooks/usePermissions';
import {
  RedisClient,
  Permissions,
  SubscriptionResponse,
  LimitsResponse,
  TeamUsageResponse,
  ServiceUsageResponse,
  UsePermissionsOptions,
  UsePermissionsReturn
} from './types';

// Singleton instance with Redis support
let defaultInstance: PermissionService | null = null;

const createPermissionService = (redisClient: RedisClient | null = null, sessionId: string | null = null, baseURL: string): PermissionService => {
  return new PermissionService(redisClient, sessionId, baseURL);
};

const getDefaultInstance = (redisClient: RedisClient | null = null, sessionId: string | null = null, baseURL: string): PermissionService => {
  if (!defaultInstance) {
    defaultInstance = createPermissionService(redisClient, sessionId, baseURL);
  } else {
    if (baseURL) defaultInstance.setBaseURL(baseURL);
    if (redisClient && !defaultInstance.isRedisConnected()) {
      defaultInstance.setRedisClient(redisClient);
    }
    if (sessionId) {
      defaultInstance.setSessionId(sessionId);
    }
  }
  return defaultInstance;
};

// Export everything
export {
  PermissionService,
  usePermissions,
  createPermissionService,
  getDefaultInstance
};

// Type exports
export type {
  RedisClient,
  Permissions,
  SubscriptionResponse,
  LimitsResponse,
  TeamUsageResponse,
  ServiceUsageResponse,
  UsePermissionsReturn,
  UsePermissionsOptions
};

// Default export for convenience
export default getDefaultInstance;